<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <template v-if="contents.items.length">
                <div :class="this.gridClassArray">
                  <template v-for="(item, index) in contents.items">
                    <div :class="['amp-img', 'slide-img', 'amp-img-cover', item.image.width > item.image.height ? 'landscape' : 'portrait']">
                      <mimic-amp-img :image="item.image"></mimic-amp-img>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="component-warning flex justify-center items-center">
                  <span class="component-warning-span">画像を選択してください</span>
                </div>
              </template>
            </div>
          </section>

        </div>
      </div>

      <el-dialog width="90%" title="画像の選択" :visible.sync="dialogImageSelectVisible">
        <select-image v-model="selectedImage" @change="onUpdateImage"></select-image>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogImageSelectVisible = false">キャンセル</el-button>
          <el-button type="primary" @click="onUpdateImage">選択</el-button>
        </span>
      </el-dialog>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="画像の選択" label-width="170px">
          <template v-for="(item, index) in contents.items">
            <div class="flex items-center my1">
              <div class="flex column items-center">
                <el-button class="my1" @click="onSelectImage(index)">画像の選択</el-button>
                <template v-if="index > 0">
                  <el-button class="my1" style="margin-left:0" @click="onDeleteImage(index)">画像の削除</el-button>
                </template>
              </div>
              <div class="image-thumbnail flex column justify-between items-center ml2">
                <img class="image-thumbnail-img" :src="item.image.src">
                <p class="image-thumbnail-size">画像のサイズ：{{ item.image.width }}x{{ item.image.height }}</p>
              </div>
              <el-input class="width-50 ml2" v-model="item.link.href" auto-complete="off" placeholder="リンク先URL"></el-input>
            </div>
          </template>
          <el-button class="my1" @click="onAddImage">画像の追加</el-button>
        </el-form-item>
        <el-form-item label="スマホサイズで横に並べる画像の数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.s" controls-position="right" :min="1" :max="3"></el-input-number><span class="pl4">最大3まで</span>
        </el-form-item>
        <el-form-item label="タブレットサイズで横に並べる画像の数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.m" controls-position="right" :min="1" :max="4"></el-input-number><span class="pl4">最大4まで</span>
        </el-form-item>
        <el-form-item label="デスクトップサイズで横に並べる画像の数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.l" controls-position="right" :min="1" :max="6"></el-input-number><span class="pl4">最大6まで</span>
        </el-form-item>
        <el-form-item label="画像間の余白" :label-width="labelWidth">
           <el-slider v-model="contents.layout.margin" :step="1" :min="0" :max="5"></el-slider>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import SelectImage from '@/components/app/SelectImage'

export default {
  name: 'slide-images-1',
  components: {
    'mimic-amp-img': MimicAmpImg,
    'select-image': SelectImage
  },
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '20em',
      selectedImage: {
        id: null,
        src: null,
        width: null,
        height: null,
        index: null
      },
      dialogImageSelectVisible: false
    }
  },
  computed: {
    // imagesReduced: function () {
    //   return this.media.map(image => ({
    //     id: image.id,
    //     src: image.source_url,
    //     width: image.media_details.width,
    //     height: image.media_details.height,
    //     alt_text: image.alt_text
    //   }))
    // }
  },
  methods: {
    /**
     * 「画像の選択」ボタンがクリックされたら、contents.items[index].imageの各プロパティを
     * this.selectedImageにコピーする
     */
    onSelectImage: function (index) {
      // migration
      // if (!this.contents.items[index].image.id) {
      //   try {
      //     this.contents.items[index].image.id = this.media.find(img => img.source_url === this.contents.items[index].image.src).id
      //   } catch (e) {
      //     console.log(e)
      //     this.contents.items[index].image.id = 0
      //   }
      // }
      this.selectedImage.id = this.contents.items[index].image.id
      this.selectedImage.src = this.contents.items[index].image.src
      this.selectedImage.width = this.contents.items[index].image.width
      this.selectedImage.height = this.contents.items[index].image.height
      this.selectedImage.index = index
      this.dialogImageSelectVisible = true
    },
    /**
     * ダイアログで画像を選択したら、選択した画像をidを元にthis.mediaから探し、
     * その画像の情報をthis.contents.items[selectedImage.index]に格納する
     */
    onUpdateImage: function () {
      const selected = this.media.find(image => image.id === this.selectedImage.id)

      this.contents.items[this.selectedImage.index].image.id = selected.id
      this.contents.items[this.selectedImage.index].image.src = selected.source_url
      this.contents.items[this.selectedImage.index].image.width = selected.media_details.width
      this.contents.items[this.selectedImage.index].image.height = selected.media_details.height

      this.dialogImageSelectVisible = false

      this.selectedImage.id = null
      this.selectedImage.src = null
      this.selectedImage.width = null
      this.selectedImage.height = null
      this.selectedImage.index = null
    },
    onAddImage: function () {
      this.contents.items.push({
        image: {
          id: 0,
          src: 'http://via.placeholder.com/350x150',
          width: 350,
          height: 150
        },
        link: {
          href: '',
          blank: false
        }
      })
    },
    onDeleteImage: function (index) {
      this.contents.items.splice(index, 1)
    },
    resetImage: function () {
      this.contents.images = []
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const ampImages = contents.items.reduce((acc, item) => {
        const imageDirection = item.image.width > item.image.height ? 'landscape' : 'portrait'
        const ampImage = `<amp-img class="slide-img amp-img-cover ${imageDirection}" width="${item.image.width}" height="${item.image.height}" layout="responsive" src="${item.image.src}"></amp-img>`
        return acc + (item.link.href ? `<a class="block" href="${item.link.href}">${ampImage}</a>` : `<div>${ampImage}</div>`)
      }, '')

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <div class="${this.gridClass}">
            ${ampImages}
          </div>
        </div>
      </section>`.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.native {
  @import './SlideImages1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './SlideImages1.s.scss';
}
.tablet,
.desktop {
  @import './SlideImages1.m.scss';
}
.desktop {
  @import './SlideImages1.l.scss';
}

.image-select {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ddd;
  padding: 10px 0;
  height: 300px;
  overflow: scroll;
  &-item {
    width: 156px;
    height: 156px;
  }
  &-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &-input {
    display: none;
    &:checked ~ .image-select-label:after {
      border: 3px solid $--color-danger;
    }
  }
  &-label {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.image-thumbnail {
  width: 240px;
  height: 120px;
  position: relative;
  overflow: hidden;
  background-color: #f4f3fa;
  &-img {
    margin: auto;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    max-height: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: contain;
  }
  &-size {
    margin: auto;
    width: 100%;
    position: absolute;
    bottom: 0;
    line-height: 1;
    text-align: center;
    background-color: rgba(255,255,255,.7);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contents/SlideImages1/SlideImages1.vue